import { FileMetaData } from '@oh-vcp/components-common';
import { useQuery, useQueryClient } from 'react-query';
import apiService from './apiService';

const fetchFileDetails = async (
  fileId: string,
  fileAccessKey?: string
): Promise<FileMetaData | null> => {
  let url = `files/${fileId}/info`;
  if (fileAccessKey) {
    url = `/files/${fileId}/info?file_access_key=${fileAccessKey}`;
  }
  const response = await apiService.get(url, {
    ignoreError: true
  });
  if (response && response.data) {
    return response.data;
  }
  return null;
};

const useFileService = (fileId: number | undefined, fileAccessKey?: string) => {
  const queryClient = useQueryClient();

  const result = useQuery<FileMetaData | null>(
    ['useFileService', fileId, fileAccessKey],
    () => fetchFileDetails(fileId?.toString() || '', fileAccessKey),
    {
      enabled: !!fileId,
      refetchOnWindowFocus: false
    }
  );

  const fetchById = async (id: number): Promise<FileMetaData | null> => {
    return queryClient.fetchQuery(['useFileService', id], () => fetchFileDetails(id.toString()));
  };

  return {
    ...result,
    fetchById
  };
};

export default useFileService;
